// extracted by mini-css-extract-plugin
export default {"h1":"Htag_h1__E5Bdo","h2":"Htag_h2__LEE3G","h3":"Htag_h3__GIVGy","blueColor":"Htag_blueColor__eCB1M","wrapper":"Htag_wrapper__2djKy"};